define('app/views/rating_sort_deals',['app/setup', 'app/lib/lockr'], function(takhfifan) {

  takhfifan.ratingSortDeals = Backbone.View.extend({
    events: {
      'click .sorting-item' : 'toggleDealsSort',
      'click .sorting-wrapper ' : 'openSortingMenu',
    },
    initialize: function() {
      var _this = this;
      this.sorted = false;
      this.$delasList = $(this.$el.data('list'));
      this.$deals = this.$delasList.find('.deal');
      this.catFilteredId = -1;
      takhfifan.eventHub.on('subcategory-filtered',function (catId) {
        _this.catFilteredId = catId;
      });

    },
    openSortingMenu : function(){
      $('.sorting-options').toggleClass("open");
      $('.icon-arrow-down').toggleClass("icon-arrow-up");
    },
    toggleDealsSort: function (current) {
      var $sortedDeals = this.$deals.clone(),
          _this  = this,
          sortCondition = "sort_order";

      if(current){
        $(".sorting-item").removeClass("active");
        $(".sorting-options").removeClass("open");
        $('.icon-arrow-down').toggleClass("icon-arrow-up");
        current.target.className += " active";
        $(".sorting-name").text(current.target.dataset.name);
        sortCondition = current.target.dataset.sort;
      }

      $sortedDeals.sort(function(a,b){
        var av = parseFloat($(a).data(sortCondition)),
          bv = parseFloat($(b).data(sortCondition));
        if(sortCondition === "price-low" || sortCondition === "sort_order"){
          return (av - bv);
        } else {
          return (bv - av);
        }
      });

      var visibleIndex = 0;
      $sortedDeals.each(function () {
        var $this = $(this),
            isVisible = true;
        $this.removeClass('visible-item-3n visible-item-2n');

        if(_this.catFilteredId !== -1){
          if($this.is("[data-categoryid~='"+_this.catFilteredId+"']")){
            $this.css('display','block')
          }else{
            $this.css('display','none');
            isVisible = false;
          }
        }

        if ((visibleIndex + 1) % 3 === 0) {
          $this.addClass('visible-item-3n')
        }
        if ((visibleIndex + 1) % 2 === 0) {
          $this.addClass('visible-item-2n')
        }

        if(isVisible){visibleIndex++}
      });
      this.$delasList.html($sortedDeals);
      takhfifan.eventHub.trigger('lazyLoad:notify');
    }

  });
});

